import { useLoaderData, LoaderFunctionArgs } from "react-router-dom";
import { DEFERRED_REPORT } from "./fragment";
import { colDefs } from "./helpers";
import { ReportFilters } from "../components/ReportFilters";
import ReportHeader from "../components/ReportHeader";
import { userStore } from "../../../store/user";
import { createApolloClient } from "../../../providers/ApolloClientFactory";
import { organizationStore } from "../../../store/organization";
import { DeferredReportRow } from "./type";
import React, { useRef } from "react";
import { eventStore } from "../../../store/event";
import { GridApi, SizeColumnsToContentStrategy } from "ag-grid-community";
import { SecondaryButton } from "../../../components/Button";
import { AgGridReact } from "ag-grid-react";

const client = createApolloClient();
const { getState } = userStore;
const { getState: getOrganizationState } = organizationStore;
const { getState: getEventState } = eventStore;

export const deferredTransactionsLoader = async ({
  request,
}: LoaderFunctionArgs) => {
  const rawOrganizationId = getOrganizationState().organizationId;
  const organizationId = parseInt(rawOrganizationId !== null ? rawOrganizationId.toString() : '', 10);
  const { eventId } = getEventState();
  const user = getState().user;

  const search = new URL(request.url);
  const where = search.searchParams.get("where");
  let whereVariable: any = where ? JSON.parse(where) : {};
  if (organizationId && organizationId !== 0) {
    whereVariable = {
      ...whereVariable,
      organization_id: {
        _eq: organizationId,
      },
    };
  }
  if (user?.vendors) {
    whereVariable = {
      ...whereVariable,
      vendor_id: {
        _in: user?.vendors,
      },
    };
  }

  if (eventId) {
    whereVariable = {
      ...whereVariable,
      event_id: {
        _eq: eventId,
      },
    };
  } else if (user?.events) {
    whereVariable = {
      ...whereVariable,
      event_id: {
        _in: user?.events,
      },
    };
  }
  whereVariable = {
    ...whereVariable,
    payment_status: {
      _eq: "pending",
    },
  };
  const { data } = await client.query({
    query: DEFERRED_REPORT,
    variables: { where: whereVariable },
  });
  return data.reports_transactions || [];
};

export const DeferredReport = () => {
  const data = useLoaderData() as DeferredReportRow[];
  const gridRef = useRef<GridApi>();
  const rowHeight = 50;
  const autoSizeStrategy: SizeColumnsToContentStrategy = {
    type: "fitCellContents",
  };
  const handleExportCSV = () => {
    if (gridRef.current) {
      const timestamp = new Date().toISOString().replace(/[-:]/g, "");
      const params = {
        fileName: `DeferredTransactionsReport_${timestamp}.csv`,
        columnSeparator: ",",
        skipHeader: false,
        allColumns: true,
      };
      gridRef.current.exportDataAsCsv(params);
    }
  };
  const gridOptions = {
    enableCellTextSelection: true,
  };

  return (
    <>
      <div className="bg-white px-4 pb-1 mb-3 rounded-md">
        <ReportHeader title="Deferred Transactions Report" />
        <ReportFilters
          includeDates
          includeTime
          includeLocations
          includeUsernames
          includeVendors
          customQueryPaths={{
            dateFrom: "_and[0].transaction_hour",
            dateTo: "_and[1].transaction_hour",
          }}
        />
        <div className="flex">
          <div className="ml-auto">
            <SecondaryButton onClick={handleExportCSV}>
              Export to CSV
            </SecondaryButton>
          </div>
        </div>
      </div>
      <div style={{ height: "60vh" }}>
        <div
          className={"ag-theme-quartz"}
          style={{ width: "100%", height: "100%" }}
        >
          <AgGridReact
            rowData={data}
            columnDefs={colDefs}
            rowHeight={rowHeight}
            autoSizeStrategy={autoSizeStrategy}
            pagination={true}
            gridOptions={gridOptions}
            paginationPageSize={100}
            // pinnedBottomRowData={totalRow}
            onGridReady={(params) => (gridRef.current = params.api)} // Set GridApi reference
          />
        </div>
      </div>
    </>
  );
};
